import SeatSelection from './SeatSelection';

export default SeatSelection;
